import { Box, Loader, Paper, Text, useMantineColorScheme } from '@mantine/core';
import ReactMarkdown from 'react-markdown';
import { useValidation } from '../../context/ValidationContext';
import { ValidateableCvSections } from '../../types/cvSections';
import { MermaidChart } from './MermaidChart';

interface ValidationResultProps {
  section: ValidateableCvSections;
}

export function ValidationResult({ section }: ValidationResultProps) {
  const { validationResults, isValidating } = useValidation();
  const { colorScheme } = useMantineColorScheme();
  const result = validationResults[section];
  const loading = isValidating[section];

  if (!result && !loading) return null;

  const isDark = colorScheme === 'dark';

  return (
    <Box mt="md">
      <Paper
        p="md"
        withBorder
        style={{
          borderLeft: '4px solid var(--mantine-color-blue-6)',
          backgroundColor: isDark
            ? 'var(--mantine-color-dark-6)'
            : 'var(--mantine-color-blue-0)'
        }}
      >
        {loading ? (
          <Box style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Loader size="sm" />
            <Text size="sm">Validating section...</Text>
          </Box>
        ) : result ? (
          <Box>
            <Text size="sm" fw={500} mb="xs">Validation Results:</Text>
            <Box style={{
              fontSize: 'var(--mantine-font-size-sm)',
              '& p': { margin: '0.15em 0' },
              '& ul, & ol': { margin: '0.15em 0', paddingLeft: '0.75em' },
              '& li': { margin: '0.1em 0' }
            }}>
              <ReactMarkdown
                components={{
                  code({ node, className, children, ...props }) {
                    const match = /language-(\w+)/.exec(className || '');
                    if (match && match[1] === 'mermaid') {
                      return <MermaidChart chart={String(children).trim()} />;
                    }
                    return (
                      <code className={className} {...props}>
                        {children}
                      </code>
                    );
                  }
                }}
              >
                {result}
              </ReactMarkdown>
            </Box>
          </Box>
        ) : null}
      </Paper>
    </Box>
  );
} 
